// // components/CustomEmailInput.js
// import React from 'react';
// import { Box } from '@mui/material';

// const CustomEmailInput = ({
//   placeholder,
//   value,
//   onChange,
//   name = 'email',
//   width,
//   height = '42px',
//   fontSize = '14px',
//   borderColor = ' #091E4224',
//   focusBorderColor = '#006EC2',
//   placeholderColor = ' #A0A0A0',
//   borderRadius = '6px',
//   ...rest
// }) => {
//   return (
//     <Box
//       sx={{
//         width: width || '100%', // ✅ fallback if not passed
//         height,
//         display: 'flex',
//         alignItems: 'center',
//         border: `2px solid ${borderColor}`,
//         borderRadius,
//         px: 1.5,
    
//         '&:focus-within': {
//           border: `2px solid ${focusBorderColor}`,
//         },
//       }}
//     >
//       <Box
//         component="input"
//         type="email"
//         name={name}
//         value={value}
//         onChange={onChange}
//         placeholder={placeholder || ''} // ✅ optional placeholder
//         sx={{
//           border: 'none',
//           outline: 'none',
//           fontSize,
//           width: '100%',
//           height: '100%',
//               backgroundColor:"none",
//                  fontFamily: 'Poppins, sans-serif',
//           color: ' #333',
//           '::placeholder': {
//             color: placeholderColor,
//           },
//             '&:-webkit-autofill': {
//       WebkitBoxShadow: '0 0 0px 1000px white inset',
//       WebkitTextFillColor: '#333',
//       transition: 'background-color 5000s ease-in-out 0s',
//     },
//         }}
//         {...rest}
//       />
//     </Box>
//   );
// };

// export default CustomEmailInput;




import React from 'react';
import { Box, Typography } from '@mui/material';

const CustomEmailInput = ({
  placeholder,
  value,
  onChange,
  onBlur,
  name = 'email',
  width,
  height = '42px',
  fontSize = '14px',
  borderColor = '#091E4224',
  focusBorderColor = '#006EC2',
  placeholderColor = '#A0A0A0',
  borderRadius = '6px',
  error = false,
  helperText = "",
  ...rest
}) => {
  return (
    <Box sx={{ width: width || '100%' }}>
      <Box
        sx={{
          height,
          display: 'flex',
          alignItems: 'center',
          // border: `2px solid ${error ? '#d32f2f' : borderColor}`,
            border:error
      ? "1px solid red"
      :"2px solid  #091E4224",
          borderRadius,
          px: 1.5,
          '&:focus-within': {
            // border: `2px solid ${error ? '#d32f2f' : focusBorderColor}`,
              border:error
      ? "1px solid red"
      :"2px solid  #006EC2",
          },
        }}
      >
        <Box
          component="input"
          type="email"
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        placeholder={placeholder || 'john@gmail.com'}
          sx={{
            border: 'none',
            outline: 'none',
            fontSize,
            width: '100%',
            height: '100%',
            fontFamily: 'Poppins, sans-serif',
            color: '#333',
            '::placeholder': { color: placeholderColor },
          }}
          {...rest}
        />
      </Box>
      {error && (
        <Typography sx={{ fontSize: 12, color: '#d32f2f', mt: 0.5 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default CustomEmailInput;
